import type { ICategory, ICustomCategory } from "app/common/services/categoryService.types";
import { DefaultFetchService } from "app/services/fetchService";

import { getQueryParams } from "../../getQueryParams";

export const createCategoryApiParams = (category: ICategory, extraParams = {}) => {
    const baseQueryParams = getQueryParams();

    return {
        ...baseQueryParams,
        ...extraParams,
        keys: category.forApi,
        category: category.categoryId,
        categoryHash: category.isCustomCategory ? category.categoryHash : "",
    };
};

export const fetchCategoryData = async <T>(
    endpoint: string,
    category: ICategory | ICustomCategory,
    extraParams = {},
): Promise<T> => {
    const fetchService = DefaultFetchService.getInstance();
    const queryParams = createCategoryApiParams(category, extraParams);
    return fetchService.get<T>(endpoint, queryParams);
};
